define('LocationShippingTimes.Configuration', [
  'underscore'
], function LocationShippingTimesConfiguration(_) {
  'use strict';

  /**
   * @type {Environment}
   */
  var environment = null;

  return {
    /**
     * @param {ComponentContainer} container
     */
    initialize: function initialize(container) {
      environment = container.getComponent('Environment');
    },

    get: function get(key, defaultValue) {
      var value;
      if (!environment) {
        console.error('LocationShippingTimes.Configuration is not initialized');
        return defaultValue;
      }
      if (!key) {
        console.error('LocationShippingTimes.Configuration.get() called with empty key.');
        return defaultValue;
      }
      value = environment.getConfig(key);
      if (_.isUndefined(value)) {
        return defaultValue;
      }
      return value;
    },

    isExcludeSaturdays: function isExcludeSaturdays() {
      return this.get('locationShippingTimes.excludeSaturdays', true);
    },

    isExcludeSundays: function isExcludeSundays() {
      return this.get('locationShippingTimes.excludeSundays', true);
    }
  };
});
